import React, { memo, useEffect } from "react";
import { labelField } from "../CommonForm/CommonFormInterface";

const Label = memo(
  ({
    field,
    extractedLabel,
    handleClick,
    handleOnMouseEnter,
    handleOnMouseLeave,
  }: {
    field: labelField;
    extractedLabel: string;
    handleClick: Function;
    handleOnMouseEnter: Function;
    handleOnMouseLeave: Function;
  }) => {
    const LabelType = field.labelType;
    return (
      <LabelType
        className={field.className}
        style={field?.style}
        id={field?.id}
        onClick={(e) => handleClick(e)}
        onMouseEnter={(e) => handleOnMouseEnter(e)}
        {...(field?.properties?.onMouseLeave
          ? { onMouseLeave: (e) => handleOnMouseLeave(e) }
          : {})}
        {...(field?.properties?.onMouseEnter
          ? { onMouseLeave: (e) => handleOnMouseLeave(e) }
          : {})}
        {...(field?.actions
          ? { onMouseLeave: (e) => handleOnMouseLeave(e) }
          : {})}
      >
        {extractedLabel}
      </LabelType>
    );
  }
);

export default Label;
